import React from "react"
import './fade.scss'

export default function Fade(props: any) {
    return (
        <div className="layout-fade d-flex justify-content-center align-items-center">
            {props.children}
        </div>
    )
}